import script from "./AlertsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertsDialog.vue?vue&type=script&setup=true&lang=js"

import "./AlertsDialog.vue?vue&type=style&index=0&id=5fc35b8e&lang=scss"

const __exports__ = script;

export default __exports__